module.exports = __webpack_public_path__ + "static/mobile_03@2x-e557beb61c3fa5e9bdd49a692231cbae.png";